<template>
  <div>
    <div
      @click="$router.push('/category/summer')"
      class="bg h-72 rounded-xl duration-700 mb-6"
      style="background-image: url('https://bit.ly/3yQCnSd')"
    >
      <div
        class="flex items-end bottom-0 right-0 w-full h-full rounded-xl text-white p-4"
      >
        <p class="w-full">
          <a class="text-3xl uppercase font-medium tracking-wider">
            {{ $t("home.banner.title") }}
          </a>
          <br />
          <a class="text-lg" v-html="$t('home.banner.dis')"></a>
        </p>
      </div>
    </div>
    <p>
      <a class="text-3xl uppercase font-medium tracking-wider">{{
        $t("home.slogan.title")
      }}</a>
      <br />
      <a class="text-xl">{{ $t("home.slogan.dis") }}</a>
    </p>
    <h5 class="text-sm pb-6">{{ $t("home.slogan.sub") }}</h5>
    <div class="between">
      <h1 class="text-lg font-medium tracking-wide">
        {{ $t("fixed.category.group") }}
      </h1>
      <svg
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        class="w-4"
      >
        <path
          fill-rule="evenodd"
          d="M3 7a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 13a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </div>
    <carousel
      :rtl="$doc('html').dir == 'rtl'"
      :paginationActiveColor="
        $doc('html').classList.contains('dark') ? '#fff' : '#364055'
      "
      paginationColor="#36405550"
      :loop="true"
      :autoplay="true"
      :per-page="1.5"
      class="mb-12"
    >
      <slide v-for="category in categorys" :key="category.id" class="mr-4">
        <div
          @click="$router.push(`/category/${$t(category.title)}`)"
          class="bg h-24 rounded-xl"
          :style="`background-image: url(${category.img})`"
        >
          <div
            class="top-0 right-0 w-full h-full rounded-xl bg-gray-700 bg-opacity-30 g-center text-white text-2xl first-letter:uppercase"
          >
            {{ $t(`fixed.category.${category.title}`) }}
          </div>
        </div>
      </slide>
      <slide>
        <div class="h-24 w-8/12 center"></div>
      </slide>
    </carousel>

    <div v-for="category in categorys" :key="category.id" class="grid-1">
      <div @click="$router.push(`/category/${category.title}`)" class="between">
        <h1 class="text-lg font-medium tracking-wide first-letter:uppercase">
          {{ $t(`fixed.category.${category.title}`) }}
        </h1>
        <svg
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          class="w-4"
        >
          <path
            fill-rule="evenodd"
            d="M3 7a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 13a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>
      <carousel
        :rtl="$doc('html').dir == 'rtl'"
        :paginationEnabled="false"
        :per-page="3"
        class="mb-6"
      >
        <slide
          v-for="product in category.products"
          :key="product.id"
          class="w-24 mr-4"
        >
          <div
            class="bg-0 bg-slate-100 h-32 rounded-xl"
            @click="$router.push(`/product/${product.id}`)"
            :style="`background-image: url(${product.images[0]})`"
          ></div>
          <div dir="auto" class="px-4">
            <div class="truncate mt-2">{{ product.name }}</div>
            <div class="start">
              <h1 class="font-medium">{{ product.price }}</h1>
              <h6 class="text-xs mx-2">DZD</h6>
            </div>
          </div>
        </slide>
        <slide>
          <div class="h-32"></div>
        </slide>
        <slide>
          <div class="h-32"></div>
        </slide>
      </carousel>
    </div>
    <h1 class="text-lg font-medium tracking-wide text-center mb-4">Partners</h1>
    <carousel
      :rtl="$doc('html').dir == 'rtl'"
      :paginationEnabled="false"
      :loop="true"
      :autoplay="true"
      :per-page="2"
    >
      <slide v-for="item in partners" :key="item.id" class="m-auto">
        <div @click="$router.push(`/category/${item}`)">
          <svgApp :type="item" />
        </div>
      </slide>
    </carousel>
    <a
      href="https://facebook.com/lazirijs"
      target="_blank"
      class="tracking-wider text-center mt-12 text-xs text-slate-500 dark:text-slate-400"
    >
      created by LAZIRI <br class="p-2" />
      facebook.com/lazirijs
    </a>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import svgApp from "@/components/svgApp.vue";
import { db } from "@/assets/db";

export default {
  beforeCreate() {
    !localStorage.start ? this.$router.push("/start") : false;
  },
  components: {
    svgApp,
    Carousel,
    Slide,
  },
  data() {
    return {
      categorys: [
        {
          title: "summer",
          img: "https://bit.ly/3yLU9G6",
          products: [],
        },
        {
          title: "trending",
          img: "https://bit.ly/3yqmL6m",
          products: [],
        },
        {
          title: "tshirts",
          img: "https://bit.ly/3AOs3f5",
          products: [],
        },
        {
          title: "shoes",
          img: "https://bit.ly/3arL1gr",
          products: [],
        },
        {
          title: "watches",
          img: "https://bit.ly/3PbP0N6",
          products: [],
        },
        {
          title: "sports",
          img: "https://bit.ly/3nJb1qD",
          products: [],
        },
      ],
      used: [],
      partners: [],
    };
  },
  async created() {
    const data = await db.products.toArray();

    let categorys = this.categorys.map((category) => category.title);
    for (let index = 0; index < data.length; index++) {
      const product = data[index];

      if (!this.partners.includes(product.mark)) {
        this.partners.push(product.mark);
      }

      categorys.forEach((category) => {
        let i = this.categorys.findIndex((x) => x.title == category);
        if (
          product.category.includes(category) &&
          !this.used.includes(product.id) &&
          this.categorys[i].products.length < 6
        ) {
          this.categorys[i].products.push(product);
          this.used.push(product.id);
        }
      });
    }
  },
};
</script>
